webpackJsonp([131683993344931],{

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        "footer",
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-12" },
	                    "Copyright ",
	                    new Date().getFullYear(),
	                    " By Paul Kimbrel"
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(27);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var metadata = _ref.metadata,
	        hero = _ref.hero,
	        heroPosition = _ref.heroPosition;
	
	    var heroStyle = {};
	
	    if (hero !== undefined) {
	        heroPosition = heroPosition ? heroPosition : "70%";
	        heroStyle = {
	            "background": "url('/images/hero/" + hero + "')",
	            "backgroundPosition": "center " + heroPosition,
	            "backgroundSize": "cover"
	        };
	    }
	
	    return _react2.default.createElement(
	        'header',
	        { className: 'bodyHeader', style: heroStyle },
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            hero ? _react2.default.createElement('meta', { property: 'og:image', content: "https://www.paulkimbrel.com/images/hero/" + hero }) : _react2.default.createElement('meta', { property: 'og:image', content: 'https://www.paulkimbrel.com/images/self-pk.jpg' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-3' },
	                    _react2.default.createElement(
	                        'a',
	                        { href: '/' },
	                        _react2.default.createElement('img', { className: 'profile-image img-circle', src: '/images/profile-pic.jpeg', alt: 'Paul Kimbrel' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-9 profile-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'profile' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'a',
	                                { href: '/' },
	                                metadata.title
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'h2',
	                            { className: 'desciption' },
	                            metadata.subtitle
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'global-social list-inline' },
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://www.twitter.com/pkimbrel', target: '_blank' },
	                                    _react2.default.createElement('i', { className: 'fa fa-twitter' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'http://instagram.com/pkimbrel', target: '_blank' },
	                                    _react2.default.createElement('i', { className: 'fa fa-instagram' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://www.linkedin.com/in/pkimbrel/', target: '_blank' },
	                                    _react2.default.createElement('i', { className: 'fa fa-linkedin-square' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://soundcloud.com/paul-kimbrel', target: '_blank' },
	                                    _react2.default.createElement('i', { className: 'fa fa-soundcloud' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://plus.google.com/114118871174996663491/posts', target: '_blank' },
	                                    _react2.default.createElement('i', { className: 'fa fa-google-plus-square' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://github.com/pkimbrel', target: '_blank' },
	                                    _react2.default.createElement('i', { className: 'fa fa-github' })
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(35);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var slug = _ref.slug;
	    return _react2.default.createElement(
	        'nav',
	        { className: 'navbar navbar-default navbar-static-top', role: 'navigation' },
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'navbar-header' },
	                _react2.default.createElement(
	                    'button',
	                    { type: 'button', className: 'navbar-toggle collapsed', 'data-toggle': 'collapse', 'data-target': '.navbar-collapse' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'sr-only' },
	                        'Toggle navigation'
	                    ),
	                    _react2.default.createElement('span', { className: 'icon-bar' }),
	                    _react2.default.createElement('span', { className: 'icon-bar' }),
	                    _react2.default.createElement('span', { className: 'icon-bar' })
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'navbar-brand visible-xs-block' },
	                    'Navigate'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'navbar-collapse collapse' },
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'nav navbar-nav' },
	                    _react2.default.createElement(
	                        'li',
	                        { className: slug === "/" ? 'active' : '' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/' },
	                            'Home'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: slug.indexOf("/articles") === 0 ? 'active' : '' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/articles/1' },
	                            'Articles'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: slug.indexOf("/music") === 0 ? 'active' : '' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/music' },
	                            'Music'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: slug.indexOf("/photos") === 0 ? 'active' : '' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/photos' },
	                            'Photos'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTwitterWidgets = __webpack_require__(55);
	
	var _reactHelmet = __webpack_require__(27);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _header = __webpack_require__(84);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _navigation = __webpack_require__(85);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _footer = __webpack_require__(83);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var post = data.markdownRemark;
	  var slug = data.markdownRemark.fields.slug;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_header2.default, { metadata: data.site.siteMetadata,
	      hero: data.markdownRemark.frontmatter.hero,
	      heroPosition: data.markdownRemark.frontmatter.heroPosition }),
	    _react2.default.createElement(_navigation2.default, { slug: slug }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container main-section' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Paul Kimbrel - ',
	          post.frontmatter.title
	        ),
	        _react2.default.createElement('meta', { property: 'og:title', content: "Paul Kimbrel - " + post.frontmatter.title }),
	        _react2.default.createElement('meta', { property: 'og:type', content: 'article' }),
	        _react2.default.createElement('meta', { property: 'og:url', content: "https://www.paulkimbrel.com" + slug }),
	        _react2.default.createElement('meta', { property: 'og:description', content: post.excerpt }),
	        _react2.default.createElement('meta', { property: 'og:site_name', content: 'Paul Kimbrel - Internet hub for Paul Kimbrel, Web Developer and Systems Architect, Sound Engineer.' }),
	        _react2.default.createElement('meta', { property: 'article:published_time', content: post.frontmatter.date + "T00:0:00+00:00" }),
	        _react2.default.createElement('meta', { property: 'article:modified_time', content: post.frontmatter.date + "T00:0:00+00:00" }),
	        _react2.default.createElement('meta', { property: 'fb:admins', content: '1014995487' }),
	        _react2.default.createElement('meta', { property: 'fb:app_id', content: '345839352494303' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-8 level-one' },
	          _react2.default.createElement(
	            'article',
	            null,
	            _react2.default.createElement(
	              'header',
	              null,
	              _react2.default.createElement(
	                'h2',
	                { className: 'withDate' },
	                post.frontmatter.title
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'time',
	                  { dateTime: post.frontmatter.date },
	                  post.frontmatter.date
	                )
	              )
	            ),
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: post.html } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4 level-two' },
	          _react2.default.createElement(_reactTwitterWidgets.Timeline, { dataSource: { sourceType: "profile", screenName: "pkimbrel" },
	            options: { username: "reactjs", height: "500" } })
	        )
	      )
	    ),
	    _react2.default.createElement(_footer2.default, null)
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-article-js-040ed72a728b0600f700.js